import React, { useState, useEffect } from 'react';
import '../CSS/Global.css';
import { useSidebar } from '../SidebarContext';
import Header from './Header';
import Sidebar from './SideBar';
import OfferingModal from './OfferingModal';
import CouponModal from './CouponModal';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';

const Coupon = () => {
    const { isSidebarOpen } = useSidebar();

    // State Variables
    const [searchQuery, setSearchQuery] = useState('');
    const [coupons, setCoupons] = useState([]);
    const [filteredCoupons, setFilteredCoupons] = useState(coupons);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [couponform, setCouponForm] = useState({
        Coupon: "",
        percentage_offer: "",
        price_offer: "",
        start: "",
        end: "",
        used_by: "",
        status: ""
    })


    const statusOptions = [
        { value: 'Active', label: 'Active' },
        { value: 'Inactive', label: 'Inactive' },
    ];


    // Effect to handle filtering
    useEffect(() => {
        const filtered = coupons.filter((coupon) =>
            Object.values(coupon).some((value) =>
                String(value).toLowerCase().includes(searchQuery.toLowerCase())
            )
        );
        setFilteredCoupons(filtered);
        setCurrentPage(1); // Reset to first page on new search
    }, [searchQuery, coupons]);

    // Pagination Logic
    const totalPages = Math.ceil(filteredCoupons.length / itemsPerPage);
    const currentData = filteredCoupons.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    // Handlers
    const handleSearch = (e) => setSearchQuery(e.target.value);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    // Toggle Status


    const handleDelete = (couponId) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "Do you want to delete this coupon?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await fetch(`https://releasesworld.100billionoms.com/coupon/${couponId}`, {
                        method: 'DELETE'
                    });
                    const data = await response.json();

                    if (response.ok) {
                        Swal.fire('Deleted!', data.message, 'success');
                        fetchCoupon(); // Refresh list after delete
                    } else {
                        Swal.fire('Failed', data.message || 'Failed to delete', 'error');
                    }
                } catch (error) {
                    Swal.fire('Error', 'Server error occurred', 'error');
                    console.error(error);
                }
            }
        });
    };

    const toggleStatus = async (id) => {
        try {
            const res = await fetch(`https://releasesworld.100billionoms.com/coupon/toggle-status/${id}`, {
                method: 'PUT'
            });

            const result = await res.json();

            if (res.ok) {
                toast.success(result.message);
                fetchCoupon(); // Refresh list
            } else {
                toast.error(result.message || "Failed to toggle status");
            }
        } catch (error) {
            toast.error("Server error");
            console.error(error);
        }
    };


    const handleChange = (e) => {
        const { name, value } = e.target;
        setCouponForm((prev) => ({ ...prev, [name]: value }));
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        const isEdit = couponform.id !== undefined;
        const url = isEdit
            ? `https://releasesworld.100billionoms.com/coupon/change/${couponform.id}`
            : `https://releasesworld.100billionoms.com/coupon/admin1997`;
        const method = isEdit ? 'PUT' : 'POST';

        const payload = {
            Coupon: couponform.Coupon,
            percentage_offer: couponform.percentage_offer || null,
            price_offer: couponform.price_offer || null,
            start_date: couponform.start,
            end_date: couponform.end,
            used_by: couponform.used_by,
            status: couponform.status?.value
        };

        try {
            const res = await fetch(url, {
                method,
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });

            const result = await res.json();
            if (res.ok) {
                const mappedResult = {
                    id: result.id,
                    Coupon: result.Coupon,
                    percentage_offer: result.percentage_offer,
                    price_offer: result.price_offer,
                    start_date: result.start_date,
                    end_date: result.end_date,
                    used_by: result.used_by,
                    status: couponform.status?.value
                };


                toast.success(isEdit ? 'Coupon updated' : 'Coupon added');
                fetchCoupon();
                // setCoupons(prev => isEdit
                //     ? prev.map(c => c.id === result.id ? mappedResult : c)
                //     : [...prev, mappedResult]
                // );


                setIsModalOpen(false);
                setCouponForm({
                    Coupon: "",
                    percentage_offer: "",
                    price_offer: "",
                    start: "",
                    end: "",
                    used_by: "",
                    status: ""
                });
            } else {
                toast.error(result.message || "Save failed");
            }
        } catch (err) {
            toast.error("Server error");
            console.error(err);
        }
    };


    const fetchCoupon = async () => {
        try {
            const response = await fetch(`https://releasesworld.100billionoms.com/coupon/admin1997`)
            const res = await response.json();
            setCoupons(res)
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        fetchCoupon();
    }, [])


    return (
        <>
            <Header />
            <Sidebar />
            <div className={`open-close ${isSidebarOpen ? 'open' : 'closed'}`}>
                <div className="oms-header">
                    <h1 className="dashboard-title">Coupon</h1>

                    {/* Add Offers Button */}
                    <button className="oms-add-btn" onClick={() => setIsModalOpen(true)}>
                        Add coupon
                    </button>
                </div>

                {/* Search Filter */}
                <div className="filter-search">
                    <div className="filter-search-input">
                        <input
                            type="search"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                        />
                        <i className="fa fa-search"></i> {/* Font Awesome Search Icon */}
                    </div>
                </div>

                {/* Customer Table */}
                <div className="customer-table">
                    <table>
                        <thead>
                            <tr>
                                <th>Coupon</th>
                                <th>Discount (%)</th>
                                <th>Price Discount</th>
                                <th>Start</th>
                                <th>End</th>
                                <th>Usage</th>
                                <th>Status</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentData.length > 0 ? (
                                currentData.map((customer, index) => (
                                    <tr key={index}>
                                        <td>{customer.Coupon}</td>
                                        <td>
                                            {customer.percentage_offer !== null && customer.percentage_offer !== undefined
                                                ? customer.percentage_offer + "%"
                                                : "-"}
                                        </td>

                                        <td>{customer.price_offer || "-"}</td>
                                        <td>{customer.start_date || "-"}</td>
                                        <td>{customer.end_date || "-"}</td>
                                        <td>{customer.used_by || "-"}</td>
                                        <td>
                                            <button
                                                className={`status-toggle ${customer.status ? 'Active' : 'Inactive'}`}
                                                onClick={() => toggleStatus(customer.id)}

                                            >
                                                {customer.status === "Active" ? (
                                                    <i className="fas fa-toggle-on"></i> // Active
                                                ) : (
                                                    <i className="fas fa-toggle-off"></i> // Inactive
                                                )}
                                            </button>
                                        </td>
                                        <td>
                                            <button
                                                className="edit-button"
                                                onClick={() => {
                                                    setCouponForm({
                                                        id: customer.id, // include ID for PUT request
                                                        Coupon: customer.Coupon,
                                                        percentage_offer: customer.percentage_offer || "",
                                                        price_offer: customer.price_offer || "",
                                                        start: customer.start_date,
                                                        end: customer.end_date,
                                                        used_by: customer.used_by,
                                                        status: statusOptions.find(
                                                            opt => opt.value.toLowerCase() === (customer.status || '').toLowerCase()
                                                        ) || null


                                                    });
                                                    setIsModalOpen(true);
                                                }}
                                            >
                                                <i className="fa-solid fa-pencil edit-oms"></i>
                                            </button>

                                            <button
                                                className="delete-button"
                                                onClick={() => handleDelete(customer.id)}

                                            >
                                                <i className="fa-solid fa-trash delete-oms"></i>
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="8" style={{ textAlign: 'center' }}>No coupons found.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                {/* Pagination */}
                <div className="pagination">
                    <button
                        onClick={() => paginate(currentPage - 1)}
                        disabled={currentPage === 1}
                    >
                        Previous
                    </button>
                    {Array.from({ length: totalPages }, (_, index) => (
                        <button
                            key={index}
                            onClick={() => paginate(index + 1)}
                            className={currentPage === index + 1 ? 'active' : ''}
                        >
                            {index + 1}
                        </button>
                    ))}
                    <button
                        onClick={() => paginate(currentPage + 1)}
                        disabled={currentPage === totalPages}
                    >
                        Next
                    </button>
                </div>
            </div>

            <CouponModal isOpen={isModalOpen} setIsOpen={setIsModalOpen}
                couponform={couponform}
                setCouponForm={setCouponForm}
                handleSubmit={handleSubmit}
                statusOptions={statusOptions}
                handleChange={handleChange}
            />
        </>
    );
};

export default Coupon;
